import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ManualPayrollPreviewComponent } from '../modules/payroll/manual-payroll/manual-payroll-preview/manual-payroll-preview.component';
import { ManualPayrollComponent } from '../modules/payroll/manual-payroll/manual-payroll.component';
import { PayrollManagement } from '../tools/payroll-management';
import { manualPayrollPreviewRouteRegex, manualPayrollRouteRegex } from '../utils/regex-patterns';

@Injectable({
  providedIn: 'root'
})

// FIXME: CanDeactivate is deprecated.
// see canDeactivateCorrectionsGuard for proper usage of CanDeactivateFn
export class CanDeactivateManualPayrollGuard {
  constructor(private payrollMgmt: PayrollManagement) {}

  canDeactivate(
    c: ManualPayrollComponent | ManualPayrollPreviewComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    // if user is navigating to anywhere except /manual-payroll or /manual-payroll-preview
    if (
      c.payroll &&
      !manualPayrollRouteRegex.test(nextState?.url) &&
      !manualPayrollPreviewRouteRegex.test(nextState?.url)
    ) {
      return this.payrollMgmt.onManualPayrollDeactivate(c.payroll);
    }

    return of(true);
  }
}
